import * as PropTypes from "prop-types";
import {PatternSegment} from "./PatternSegment";


Pattern.propTypes = {
    increase: PropTypes.number,
    size: PropTypes.number,
    height: PropTypes.number,
    repeats: PropTypes.number,
    tiles: PropTypes.array,
    onTileClick: PropTypes.func,
    colors: PropTypes.array,
    editable: PropTypes.bool,
}

export function Pattern(props) {
    let segments = [];
    for (let i = 0; i < props.repeats; i++) {
        let shift = (i>0?-1:0) * (props.height/2 - 0.5);
        segments.push(
            <PatternSegment
                key={i}
                increase={props.increase}
                height={props.height}
                size={props.size}
                shift={shift}
                left={props.left}
                index={i}
                zindex={i}
                tiles={props.tiles[i]}
                onTileClick={(k,l,t) => props.onTileClick(k,i,l,t)}
                colors={props.colors}
                editable={props.editable}
            />
        );
    }
    let patternWidth =
            (props.size + 1) * (props.increase + 1) * props.repeats +
            (props.size + 1) * props.height / 2
    return (
        // set width style depending on pattern size and increase
        <div className="pattern" style={{width:patternWidth}}>
{/*
            <div className="pattern-scale">
                <div className="pattern-scale-text">
                    <span>Zunahmen</span>
                    <span>Höhe</span>
                    <span>Zunahmen</span>
                </div>
            </div>
*/}
            {segments}
        </div>
    );
}

